export default __webpack_public_path__ + "static/media/emoji_knol.963de2b0.svg";